export default "__VITE_ASSET__e54954bf__"